import { NgModule, Injectable } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { Observable } from 'rxjs';

import { CoreDialogModule } from '../core/core.module';
import { ScreenSizeService } from '../core/core';
import { ConfirmationDialogComponent, ConfirmationDialogOptions } from './confirmation.dialogcomponent';

@Injectable()
export class ConfirmationDialogService {
    smallMediaSize: boolean;

    constructor(private matDialog: MatDialog, private mediaChange?: ScreenSizeService) {
        this.smallMediaSize = this.mediaChange?.ScreenSize?.IsSmallDisplay || false;
    }

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open

    Open(options?: ConfirmationDialogOptions): Observable<boolean> {
        const self = this;
        const dlgoptions: ConfirmationDialogOptions = {
            disableClose: true,
            data: {
                TitleText: 'Confirmation Requested...',
                MessageText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                ...options,
            },
            maxHeight: '85vh', // ,
            // width: '80vw'
            // ,
            // height: (self.smallMediaSize ? '80vh' : '600px')
        };

        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        } else {
            dlgoptions.panelClass = ['confdialog'];
        }

        const openHandle = this.matDialog.open<ConfirmationDialogComponent>(ConfirmationDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}

@NgModule({
    imports: [CoreDialogModule, MatButtonModule, MatDialogModule, MatIconModule],
    declarations: [ConfirmationDialogComponent],
    exports: [ConfirmationDialogComponent],
    providers: [ConfirmationDialogService],
})
export class ConfirmationDialogModule {}
